module.exports = __webpack_public_path__ + "img/bg_pic.cdac0315.png";